// extracted by mini-css-extract-plugin
export default {"container":"Wo-z","brandName":"Xo-z","productName":"Yo-z","productNamePdpEnhancements":"Zo-z","breakLongProductName":"_o-z"};